export enum TelemetryEventType {
  PrimaryWorkflow = 0,
  SecondaryWorkflow = 1,
  BackgroundProcess = 2,
  ThirdPartyIntegration = 3
}
